import { pushLeadCreated } from './sendToGtm';

/**
 * Intercepts the beforeRedirect event in order to send tracking data to GTM.
 * @param {Event} event - The event sent by mslf.beforeRedirect
 */
export default function handleBeforeRedirect(event) {
  const { form } = event.detail;
  pushLeadCreated(form, { lead_type: '1on1_tutoring' });
}
